import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_Ehunvmipw4zl: {
	id: 'prd_Ehunv2DEV2mipw4zl'
	ident: 'prd_Ehunvmipw4zl'
	sku: 'simple_premium_1w_4_15_4w_44_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 1
			iteration_count: 1
			price_id: 'prc_cqYPm2DEV2bqmNQdD'
			amount: 22
			amount_usd: 4.15
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 4.15
			discount: 17.85
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_piyrh2DEV2dImjkHC'
			amount: 44
			amount_usd: 44
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_Ehunvmipw4zl, SubscriptionProduct>
const prd_Ehunvmipw4zl = { ident: 'prd_Ehunvmipw4zl' } as typeof _prd_Ehunvmipw4zl

export default prd_Ehunvmipw4zl
